import React from 'react';
import moment from 'moment';
import ActionButton from '../../common/ActionButton';
import { TJobItem, TUser } from '../../../types';
import { ModalConfirmCancelShift } from './ConfirmCancelShift';


type TShiftTableSubComponentProps = {
    job: TJobItem;
    user: TUser;
    updateJobStatus: (jobId: number, status: string, data?: object) => void;
    delegateJob: (jobId: number) => void;
    editJob: (jobId: number) => void;
    duplicateJob: (jobId: number) => void;
    loadCheckoutLink: (jobId: number) => void;
    viewJob: (jobId: number) => void;
    handleOpenModal: (modalName: string) => void;
    handleCloseModal: (modalName: string) => void;
    isModalConfirmCancelShiftOpen: boolean;
}

export default function ShiftTableSubComponent({
    job,
    user,
    updateJobStatus,
    delegateJob,
    editJob,
    duplicateJob,
    loadCheckoutLink,
    viewJob,
    handleOpenModal,
    handleCloseModal,
    isModalConfirmCancelShiftOpen,
}: TShiftTableSubComponentProps)  {

    return (
        <div className="expanded-content">
            <ActionButton
                text="Delegate"
                onAction={() => delegateJob(job.id)}
                show={
                    user.agency.features.includes('delegate_jobs') &&
                    job.status === 'OP' &&
                    moment(job.start_datetime) >= moment() &&
                    !job.bookings.some(booking => booking.status === 'OK')
                }
                requiredPermission="auth.manage_prejob_ops"
            />
            <ActionButton
                text="Checkout link"
                show={user.isAgent && job.status === 'IC'}
                onAction={() => loadCheckoutLink(job.id)}
                requiredPermission="auth.manage_prejob_ops"
                iconClass="icon-copy-3"
            />
            <ActionButton
                text="Duplicate"
                show={user.isAgent}
                onAction={() => duplicateJob(job.id)}
                requiredPermission="job.add_jobrequest"
            />
            <ActionButton
                text="View details"
                show={true}
                onAction={() => viewJob(job.id)}
                requiredPermission="auth.manage_prejob_ops"
            />
            <ActionButton
                text="Edit"
                show={job.is_editable || (job.managed && !job.is_cancelled)}
                onAction={() => editJob(job.id)}
                requiredPermission="job.add_jobrequest"
            />
            <ActionButton
                text="Open"
                onAction={() => updateJobStatus(job.id, 'open')}
                show={job.status === 'IC' && job.managed}
                requiredPermission="auth.manage_prejob_ops"
            />
            <ActionButton
                text="Confirm"
                onAction={() => updateJobStatus(job.id, 'confirm')}
                show={job.status === 'OP' && job.managed}
                requiredPermission="auth.manage_prejob_ops"
            />
            <ActionButton
                text="Re-open"
                onAction={() => updateJobStatus(job.id, 'reopen')}
                show={['CF', 'CL', 'OB'].includes(job.status) && job.managed}
                requiredPermission="auth.manage_prejob_ops"
            />
            <ActionButton
                text="Open backups"
                onAction={() => updateJobStatus(job.id, 'open-for-backups')}
                show={job.status === 'CF' && job.managed}
                requiredFeature="backups"
                requiredPermission="auth.manage_prejob_ops"
            />
            <ActionButton
                text="Close backups"
                onAction={() => updateJobStatus(job.id, 'confirm')}
                show={job.status === 'OB' && job.managed}
                requiredFeature="backups"
                requiredPermission="auth.manage_prejob_ops"
            />
            <ActionButton
                text="Cancel"
                show={
                    job.managed &&
                    ['CA', 'PA', 'CP'].indexOf(job.status) === -1
                }
                onAction={() => handleOpenModal('ConfirmCancelShift')}
                requiredPermission="auth.manage_prejob_ops"
            />

            {isModalConfirmCancelShiftOpen && (
                <ModalConfirmCancelShift
                    handleClose={handleCloseModal}
                    isOpen={isModalConfirmCancelShiftOpen}
                    updateJobStatus={updateJobStatus}
                    jobId={job.id}
                />
            )}
        </div>
    );
}
